import {
    CREATE_PROMO_CODE_REQUEST,
    CREATE_PROMO_CODE_SUCCESS,
    CREATE_PROMO_CODE_FAILURE,
    VALIDATE_PROMO_CODE_REQUEST,
    VALIDATE_PROMO_CODE_SUCCESS,
    VALIDATE_PROMO_CODE_FAILURE,
    APPLY_PROMO_CODE_REQUEST,
    APPLY_PROMO_CODE_SUCCESS,
    APPLY_PROMO_CODE_FAILURE,
    GET_PROMO_CODES_REQUEST,
    GET_PROMO_CODES_SUCCESS,
    GET_PROMO_CODES_FAILURE,
    DELETE_PROMO_CODE_FAILURE,
    DELETE_PROMO_CODE_REQUEST,
    DELETE_PROMO_CODE_SUCCESS,
} from './ActionType';

const initialState = {
    promoCode: null,
    appliedPromoCode: null,
    promoCodes: [],
    error: null,
    loading: false,
};

export const promoCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_PROMO_CODE_REQUEST:
        case VALIDATE_PROMO_CODE_REQUEST:
        case APPLY_PROMO_CODE_REQUEST:
        case GET_PROMO_CODES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case CREATE_PROMO_CODE_SUCCESS:
        case VALIDATE_PROMO_CODE_SUCCESS:
            return {
                ...state,
                loading: false,
                promoCode: action.payload,
            };

        case APPLY_PROMO_CODE_SUCCESS:
            return {
                ...state,
                loading: false,
                appliedPromoCode: action.payload,
            };

        case GET_PROMO_CODES_SUCCESS:
            return {
                ...state,
                loading: false,
                promoCodes: action.payload,
            };

        case CREATE_PROMO_CODE_FAILURE:
        case VALIDATE_PROMO_CODE_FAILURE:
        case APPLY_PROMO_CODE_FAILURE:
        case GET_PROMO_CODES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case DELETE_PROMO_CODE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case DELETE_PROMO_CODE_SUCCESS:
            return {
                ...state,
                loading: false,
                promoCodes: state.promoCodes.filter((code) => code._id !== action.payload),
            };

        case DELETE_PROMO_CODE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};
